module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.8.1-272.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.8.1.md
// module id = 712
// module chunks = 230